import { signOut } from "firebase/auth";
import { markAgentLogout } from "../hooks/useTimeTracking";

/**
 * Global logout across all tabs and routes.
 */
export async function globalLogout(auth, redirectTo = "/") {
  try {
    // 0. Mark agent logout for grace period (before signOut invalidates auth)
    await markAgentLogout(auth?.currentUser?.uid);

    // 1. Tell other tabs to sign out
    localStorage.setItem("force-logout", String(Date.now()));

    // Clear all auth-related keys
    const keysToClear = [
      "selectedProduct",
      "authUser",
      "redirectAfterLogin",
      "lastVisitedRoute",
      "firebase:host:thescope360.firebaseapp.com" // Common Firebase internal key
    ];
    keysToClear.forEach((k) => localStorage.removeItem(k));

    // Optional: Clear all local storage if you want a true reset
    // localStorage.clear();
    // if (theme) localStorage.setItem("scope180-theme", theme);

    // 3. Perform the Firebase Sign Out
    if (auth) {
      await signOut(auth);
    }
  } catch (e) {
    console.error("Global logout error:", e);
  } finally {
    // 4. Hard redirect using href (stronger than navigate in some browsers)
    window.location.href = redirectTo;
  }
}